// import React from "react";
// import { useRef } from "react";
// import { X } from "lucide-react";
// import moment from "moment";

// const InvoiceSaleModal = ({ open, onClose, sale }) => {
//   const receiptRef = useRef(null);

//   if (!open || !sale) return null;

//   const handlePrint = () => {
//     const receiptContent = receiptRef.current
//       ? receiptRef.current.innerHTML.replace(/undefined|null|blank/g, "")
//       : "";
//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(`
//       <html>
//       <head>
//         <style>
//           body { font-family: calibri, sans-serif; font-size: 12px; margin: 0 auto; padding: 0;}
//           .receipt-container { width: 300px; margin: 0 auto; padding: 5px;}
//           table { width: 100%; border-collapse: collapse; }
//           th, td { text-align: left; padding: 4px; }
//           th { border-bottom: 1px solid #000; }
//         </style>
//       </head>
//       <body onload="window.print(); window.close();">
//         ${receiptContent}
//       </body>
//       </html>
//     `);
//     printWindow.document.close();
//   };

//   const totalPriceSum = sale.details?.reduce((sum, med) => sum + (Number(med.total_price) || 0), 0) || 0;
//   const discountPriceSum = sale.details?.reduce((sum, med) => sum + (Number(med.discount_price) || 0), 0) || 0;
//   const finalDiscount = (totalPriceSum - discountPriceSum).toFixed(2);
  
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ml-[240px]">
//       <div
//         className="bg-white px-8 py-6 rounded-2xl w-[50%] shadow-lg relative max-h-[80vh] overflow-y-auto"
//       >
//         <button 
//           onClick={onClose} 
//           className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
//         >
//           ✖
//         </button>

//         <h1 className="text-center font-semibold text-gray-800 text-xl">Sale Invoice</h1>
//         <h2 className="text-primary font-bold text-lg mt-4">{sale.customer_name || "N/A"}</h2>

//         <div className="flex flex-col mt-1 gap-1">
//           <h1 className="font-bold text-gray-700 text-sm">
//             Invoice No : <span className="font-normal">{sale.id || "N/A"}</span>
//           </h1>
//           <h1 className="font-bold text-gray-700 text-sm">
//             Invoice Date : <span className="font-normal">{moment(sale.date).format("ll")}</span>

//           </h1>
//         </div>

//         <div className="flex w-full mt-8">
//         <div className="flex w-full mt-6 overflow-hidden rounded-lg border border-gray-300 shadow-md">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="text-xs font-semibold text-center border-b">
//                 <th className="text-start py-2 w-[3%]">Medicine</th>
//                 <th className="py-2 w-[1%]">Qty</th>
//                 <th className="py-2 w-[3%]">Total Amount</th>
//                 <th className="py-2 w-[3%]">Discounted Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               {sale.details && sale.details.length > 0 ? (
//                 sale.details.map((med, index) => (
//                   <tr key={index} className="text-center">
//                     <td className="text-start border-b-2 py-2 text-gray-700 text-sm">{med.medicine_name || "N/A"}</td>
//                     <td className="border-b-2 py-2 text-gray-700 text-sm">{med.quantity || 0}</td>
//                     <td className="border-b-2 py-2 text-gray-700 text-sm">{med.total_price || "0.00"}</td>
//                     <td className="border-b-2 py-2 text-gray-700 text-sm">{med.discount_price || "0.00"}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" className="text-center text-gray-500 py-4">
//                     No medicines found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//           </div>
//         </div>

//         <div className="flex flex-col justify-end items-end mt-10 gap-1">
//           <div>
//             <h1 className="font-bold text-gray-700 text-sm">
//               Total : <span className="font-normal">{totalPriceSum.toFixed(2) || "0.00"}</span>
//             </h1>
//             <h1 className="font-bold text-gray-700 text-sm">
//               Discount : <span className="font-normal">{finalDiscount}</span>
//             </h1>
//             <h1 className="font-bold text-gray-700 text-sm">
//               Bill Amount : <span className="font-normal">{discountPriceSum.toFixed(2) || "0.00"}</span>
//             </h1>
//           </div>
//         </div>

//         <div className="flex content-center justify-center self-center mt-5">
//           <button
//             onClick={handlePrint}
//             className="mt-5 bg-[#00A95B] text-white px-4 py-2 rounded-md hover:bg-[#00a941]"
//           >
//             Print Invoice
//           </button>
//         </div>


//         <div ref={receiptRef} className="hidden">
//   <div className="receipt-container w-[3in] font-calibri text-[10px]">
//     <div className="w-full text-center">
//       <h2 className="text-lg font-bold text-center mx-auto block">
//         Hospital Management System
//       </h2>
//     </div>
//     <h3 className="text-lg">Invoice # {sale.id || "N/A"}</h3>
//     <p className="text-sm"><strong>Patient:</strong> {sale.customer_name || "N/A"}</p>
//     <p className="text-sm"><strong>Date: </strong>{new Date(sale.date).toLocaleDateString() || "N/A"}</p>
//     <hr className="my-2 border-gray-300" />

//     <table className="w-full text-sm border-collapse table-fixed">
//       <thead>
//         <tr>
//           <th className="text-left text-sm">Name</th>
//           <th className="text-left text-sm">Qty</th>
//           <th className="text-right text-sm">Price</th>
//           <th className="text-right text-sm">Amount</th>
//         </tr>
//       </thead>
//       <tbody>
//         {sale.details?.map((row, index) => (
//           <tr key={index}>
//             <td className="text-sm">{row.medicine_name || "N/A"}</td>
//             <td className="text-sm">{row.quantity || "0"}</td>
//             <td className="text-right text-sm">{row.total_price || "0.00"}</td>
//             <td className="text-right text-sm">{row.discount_price || "0.00"}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//     <hr className="my-2 border-gray-300" />

//     {/* Right-aligned totals */}
//     <div className="w-full flex flex-col items-end text-right">
//       <h2 className="text-2xl font-bold">Total: {totalPriceSum.toFixed(2) || "0.00"}</h2>
//       <h2 className="text-2xl font-bold">Discount: {finalDiscount}</h2>
//       <h2 className="text-2xl font-bold">Bill Amount: {discountPriceSum.toFixed(2) || "0.00"}</h2>
//     </div>

//     <p className="text-sm text-center">Thank you for Your Purchase!</p>
//   </div>
// </div>

//       </div>
//     </div>
//   );
// };

// export default InvoiceSaleModal;

import React, { useRef } from "react";
import moment from "moment";
import { MdClose, MdPrint, MdReceiptLong } from "react-icons/md";

const InvoiceSaleModal = ({ open, onClose, sale }) => {
  const receiptRef = useRef(null);

  if (!open || !sale) return null;

  const totalPriceSum =
    sale.details?.reduce((sum, med) => sum + (Number(med.total_price) || 0), 0) || 0;
  const discountPriceSum =
    sale.details?.reduce((sum, med) => sum + (Number(med.discount_price) || 0), 0) || 0;
  const finalDiscount = (totalPriceSum - discountPriceSum).toFixed(2);

  const handlePrint = () => {
    const receiptContent = receiptRef.current
      ? receiptRef.current.innerHTML.replace(/undefined|null|blank/g, "")
      : "";
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
      <head>
        <style>
          body { font-family: calibri, sans-serif; font-size: 12px; margin: 0 auto; padding: 0; }
          .receipt-container { width: 300px; margin: 0 auto; padding: 5px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { text-align: left; padding: 4px; }
          th { border-bottom: 1px solid #000; }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        ${receiptContent}
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm p-2 sm:p-4 md:ml-[240px] mt-6"
    >
      <div
        className="bg-white rounded-2xl w-full max-w-[680px] shadow-2xl overflow-hidden max-h-[95vh] sm:max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="flex items-center justify-between px-4 sm:px-6 py-4 sm:py-5 bg-primary flex-shrink-0">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0">
            <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-xl bg-white bg-opacity-20 flex items-center justify-center flex-shrink-0">
              <MdReceiptLong size={16} className="text-white" />
            </div>
            <div className="min-w-0">
              <h2 className="text-white text-base sm:text-lg font-bold leading-tight truncate">
                Sale Invoice
              </h2>
              <p className="text-green-100 text-[10px] sm:text-[11px] mt-0.5 truncate">
                HMS Pharmacy
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-7 h-7 sm:w-8 sm:h-8 rounded-xl bg-white bg-opacity-20 flex items-center justify-center text-white hover:bg-opacity-30 transition-colors flex-shrink-0 ml-2"
          >
            <MdClose size={16} />
          </button>
        </div>

        {/* ── Scrollable Body ── */}
        <div className="overflow-y-auto flex-1 px-4 sm:px-6 py-4 sm:py-6">

          {/* Customer Info */}
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-6">
            <div>
              <p className="text-[11px] font-semibold tracking-wider uppercase text-gray-400 mb-1">
                Customer
              </p>
              <h3 className="text-primary font-bold text-lg sm:text-xl leading-tight break-words">
                {sale.customer_name || "N/A"}
              </h3>
            </div>
            <div className="sm:text-right">
              <div className="flex flex-row sm:flex-col flex-wrap gap-2 sm:gap-1 sm:items-end">
                <div className="flex items-center gap-2">
                  <span className="text-[11px] font-semibold tracking-wider uppercase text-gray-400">
                    Invoice No
                  </span>
                  <span className="bg-primary bg-opacity-10 text-primary text-[11px] font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    #{sale.id || "N/A"}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[11px] font-semibold tracking-wider uppercase text-gray-400">
                    Date
                  </span>
                  <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                    {moment(sale.date).format("ll")}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-dashed border-gray-200 mb-6" />

          {/* Items Table */}
          <div className="rounded-xl border border-gray-100 overflow-x-auto shadow-sm">
            <table className="w-full text-left min-w-[480px] sm:min-w-0">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-100">
                  {["Medicine", "Qty", "Total Amount", "Discounted Amt"].map((h) => (
                    <th
                      key={h}
                      className="px-2.5 sm:px-4 py-2.5 sm:py-3 text-[10px] sm:text-[11px] font-semibold uppercase tracking-wider text-gray-500 whitespace-nowrap"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sale.details && sale.details.length > 0 ? (
                  sale.details.map((med, index) => (
                    <tr
                      key={index}
                      className={`text-xs sm:text-sm border-b border-gray-50 transition-colors ${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                      } hover:bg-green-50`}
                    >
                      <td className="px-2.5 sm:px-4 py-2.5 sm:py-3 font-semibold text-gray-800">
                        {med.medicine_name || "N/A"}
                      </td>
                      <td className="px-2.5 sm:px-4 py-2.5 sm:py-3 text-gray-600">{med.quantity || 0}</td>
                      <td className="px-2.5 sm:px-4 py-2.5 sm:py-3 text-gray-600 whitespace-nowrap">
                        Rs. {Number(med.total_price || 0).toFixed(2)}
                      </td>
                      <td className="px-2.5 sm:px-4 py-2.5 sm:py-3 font-semibold text-primary whitespace-nowrap">
                        Rs. {Number(med.discount_price || 0).toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-gray-400 py-8 text-sm">
                      No medicines found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="mt-6 flex justify-end">
            <div className="w-full sm:w-auto bg-gray-50 border border-gray-100 rounded-xl px-4 sm:px-6 py-4 sm:min-w-[220px] space-y-2">
              <div className="flex justify-between gap-8 text-sm text-gray-600">
                <span className="font-medium">Subtotal</span>
                <span>Rs. {totalPriceSum.toFixed(2)}</span>
              </div>
              <div className="flex justify-between gap-8 text-sm text-gray-600">
                <span className="font-medium">Discount</span>
                <span className="text-red-500">- Rs. {finalDiscount}</span>
              </div>
              <div className="border-t border-dashed border-gray-200 pt-2 flex justify-between gap-8">
                <span className="font-bold text-gray-800 text-sm">Bill Amount</span>
                <span className="font-bold text-primary text-sm">
                  Rs. {discountPriceSum.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="px-4 sm:px-6 py-4 bg-gray-50 border-t border-gray-100 flex flex-col-reverse sm:flex-row items-center sm:justify-between gap-3 flex-shrink-0">
          <p className="text-[11px] text-gray-400 italic hidden sm:block">
            Thank you for your purchase!
          </p>
          <div className="flex gap-3 w-full sm:w-auto">
            <button
              onClick={onClose}
              className="flex-1 sm:flex-none px-5 py-2.5 rounded-xl text-sm font-semibold text-gray-500 bg-white border border-gray-200 hover:bg-gray-100 transition-colors"
            >
              Close
            </button>
            <button
              onClick={handlePrint}
              className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white bg-primary hover:bg-opacity-90 transition-all whitespace-nowrap"
            >
              <MdPrint size={16} />
              Print Invoice
            </button>
          </div>
        </div>
      </div>

      {/* ── Hidden Print Receipt ── */}
      <div ref={receiptRef} className="hidden">
        <div className="receipt-container w-[3in] font-calibri text-[10px]">
          <div className="w-full text-center">
            <h2 className="text-lg font-bold text-center mx-auto block">
              Hospital Management System
            </h2>
          </div>
          <h3 className="text-lg">Invoice # {sale.id || "N/A"}</h3>
          <p className="text-sm"><strong>Patient:</strong> {sale.customer_name || "N/A"}</p>
          <p className="text-sm"><strong>Date:</strong> {new Date(sale.date).toLocaleDateString() || "N/A"}</p>
          <hr className="my-2 border-gray-300" />
          <table className="w-full text-sm border-collapse table-fixed">
            <thead>
              <tr>
                <th className="text-left text-sm">Name</th>
                <th className="text-left text-sm">Qty</th>
                <th className="text-right text-sm">Price</th>
                <th className="text-right text-sm">Amount</th>
              </tr>
            </thead>
            <tbody>
              {sale.details?.map((row, index) => (
                <tr key={index}>
                  <td className="text-sm">{row.medicine_name || "N/A"}</td>
                  <td className="text-sm">{row.quantity || "0"}</td>
                  <td className="text-right text-sm">{row.total_price || "0.00"}</td>
                  <td className="text-right text-sm">{row.discount_price || "0.00"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr className="my-2 border-gray-300" />
          <div className="w-full flex flex-col items-end text-right">
            <h2 className="text-sm font-bold">Total: {totalPriceSum.toFixed(2)}</h2>
            <h2 className="text-sm font-bold">Discount: {finalDiscount}</h2>
            <h2 className="text-sm font-bold">Bill Amount: {discountPriceSum.toFixed(2)}</h2>
          </div>
          <p className="text-sm text-center mt-2">Thank you for your purchase!</p>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSaleModal;